
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/site/blog/stateless-mcp-server-nextjs",
      function () {
        return require("private-next-pages/site/blog/stateless-mcp-server-nextjs.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/site/blog/stateless-mcp-server-nextjs"])
      });
    }
  